import { render, staticRenderFns } from "./MIFManagement.vue?vue&type=template&id=5a18d9c6&scoped=true&"
import script from "./MIFManagement.vue?vue&type=script&lang=js&"
export * from "./MIFManagement.vue?vue&type=script&lang=js&"
import style0 from "./MIFManagement.vue?vue&type=style&index=0&id=5a18d9c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a18d9c6",
  null
  
)

export default component.exports